"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleDriveDirectoryPicker = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<button 
    type="button" 
    class="${x => x.buttonClass}" 
    @click="${x => x.openDirectoryBrowser()}"
    :disabled="${x => x.loading}">
    <span ?hidden="${x => !x.loading}" class="spinner-border spinner-border-sm me-2"></span>
    <slot><i class="fab fa-google-drive me-2" ?hidden="${x => x.loading}"></i>${x => x.buttonText}</slot>
</button>


<div ?hidden="${x => !x.selectedDirectory}" class="mt-2">
    <small class="text-muted">
        <i class="simple-icon-folder me-1"></i>
        ${'googleDrive.directoryPicker.selected'.t()}: <strong>${x => { var _a; return (_a = x.selectedDirectory) === null || _a === void 0 ? void 0 : _a.name; }}</strong>
    </small>
</div>
`;
const styles = null;
const shadowOptions = { "mode": "open" };
let GoogleDriveDirectoryPicker = class GoogleDriveDirectoryPicker extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.pickerApiLoaded = false;
        this.gisLoaded = false;
        this.accessToken = '';
        this.buttonText = 'googleDrive.directoryPicker.selectDirectory'.t();
        this.selectedDirectory = null;
        this.buttonClass = 'btn btn-primary'; // Customizable button class
        this.picker = null;
        this.tokenClient = null;
        this.apiKey = '';
        this.appId = '';
    }
    connectedCallback() {
        super.connectedCallback();
        this.initializeGoogleAPIs();
    }
    async initializeGoogleAPIs() {
        try {
            // Load Google APIs according to the official documentation
            await this.loadGooglePickerAPI();
            await this.loadGoogleIdentityServices();
        }
        catch (error) {
            console.error('Failed to initialize Google APIs:', error);
            this.notifyService.notify('googleDrive.picker.initError'.t(), 'error');
        }
    }
    async loadGooglePickerAPI() {
        return new Promise((resolve, reject) => {
            // Load the Google API Loader script first
            if (typeof gapi === 'undefined') {
                const script = document.createElement('script');
                script.src = 'https://apis.google.com/js/api.js';
                script.async = true;
                script.defer = true;
                script.onload = () => {
                    this.onApiLoad();
                    resolve();
                };
                script.onerror = () => reject(new Error('Failed to load Google API script'));
                document.head.appendChild(script);
            }
            else {
                this.onApiLoad();
                resolve();
            }
        });
    }
    async loadGoogleIdentityServices() {
        return new Promise((resolve, reject) => {
            // Load Google Identity Services
            if (typeof google === 'undefined' || !google.accounts) {
                const script = document.createElement('script');
                script.src = 'https://accounts.google.com/gsi/client';
                script.async = true;
                script.defer = true;
                script.onload = () => {
                    this.onGisLoad();
                    resolve();
                };
                script.onerror = () => reject(new Error('Failed to load Google Identity Services script'));
                document.head.appendChild(script);
            }
            else {
                this.onGisLoad();
                resolve();
            }
        });
    }
    onApiLoad() {
        // Use the API Loader script to load google.picker
        gapi.load('picker', () => {
            console.log('Google Picker API loaded successfully');
            this.pickerApiLoaded = true;
        });
    }
    async onGisLoad() {
        try {
            // Get OAuth configuration from backend
            const response = await this.apiService.back.get('settings.google-drive.config');
            if (response && response.success && response.data) {
                const { clientId, apiKey, appId } = response.data;
                this.apiKey = apiKey || '';
                this.appId = appId || '';
                if (clientId) {
                    // Initialize token client according to Google documentation
                    this.tokenClient = google.accounts.oauth2.initTokenClient({
                        client_id: clientId,
                        scope: 'https://www.googleapis.com/auth/drive.readonly',
                        callback: (response) => {
                            if (response.error !== undefined) {
                                console.error('OAuth error:', response);
                                this.notifyService.notify('googleDrive.picker.authError'.t(), 'error');
                                return;
                            }
                            this.accessToken = response.access_token;
                        }
                    });
                    this.gisLoaded = true;
                    console.log('Google Identity Services loaded successfully');
                }
                else {
                    console.error('No client ID provided');
                    this.notifyService.notify('googleDrive.picker.configError'.t(), 'error');
                }
            }
            else {
                console.error('Failed to get Google OAuth configuration');
                this.notifyService.notify('googleDrive.picker.configError'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Failed to initialize Google Identity Services:', error);
            this.notifyService.notify('googleDrive.picker.initError'.t(), 'error');
        }
    }
    /**
     * Check if Google Drive is already connected in user settings
     */
    async checkGoogleDriveStatus() {
        try {
            const response = await this.apiService.back.get('settings.google-drive.status');
            if (response && response.success && response.data) {
                return {
                    authenticated: response.data.authenticated,
                    enabled: response.data.enabled
                };
            }
        }
        catch (error) {
            console.log('Could not check Google Drive status');
        }
        return { authenticated: false, enabled: false };
    }
    async openDirectoryBrowser() {
        if (!this.pickerApiLoaded || !this.gisLoaded) {
            this.loading = true;
            this.notifyService.notify('googleDrive.picker.loading'.t(), 'info');
            await this.initializeGoogleAPIs();
            this.loading = false;
            if (!this.pickerApiLoaded || !this.gisLoaded) {
                return;
            }
        }
        try {
            this.loading = true;
            // Check Google Drive connection status first
            const status = await this.checkGoogleDriveStatus();
            if (status.authenticated) {
                // User has connected Google Drive in settings, try to use existing token
                const existingToken = await this.getExistingAccessToken();
                if (existingToken) {
                    // Use existing token from settings to open native Google Picker
                    this.accessToken = existingToken;
                    this.createNativePicker();
                    return;
                }
            }
            // Fall back to requesting new permissions if no existing token or not connected
            if (!status.authenticated) {
                // Inform user they need to connect Google Drive in settings first
                this.notifyService.notify('googleDrive.picker.connectFirst'.t(), 'warning');
                console.log('Google Drive not connected in settings, requesting permissions');
            }
            // Request new access token
            if (this.accessToken === null || this.accessToken === '') {
                // Request new access token with consent prompt for new session
                this.tokenClient.requestAccessToken({ prompt: 'consent' });
            }
            else {
                // Skip display of account chooser and consent dialog for existing session
                this.tokenClient.requestAccessToken({ prompt: '' });
            }
        }
        catch (e) {
            console.error('Failed to open directory browser:', e);
            this.notifyService.notify('googleDrive.picker.statusError'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    /**
     * Get existing access token from user settings if available
     */
    async getExistingAccessToken() {
        try {
            const response = await this.apiService.back.get('settings.google-drive.token');
            if (response && response.success && response.data && response.data.authenticated && response.data.accessToken) {
                console.log('Using existing access token from settings');
                return response.data.accessToken;
            }
        }
        catch (error) {
            console.log('No existing access token available, will request new one');
        }
        return null;
    }
    /**
     * Create and display the native Google Picker for directory selection
     */
    createNativePicker() {
        if (!this.pickerApiLoaded || !this.accessToken) {
            console.error('Picker API not loaded or no access token available');
            return;
        }
        try {
            // Create a picker builder that shows only folders
            const picker = new google.picker.PickerBuilder()
                .addView(new google.picker.DocsView(google.picker.ViewId.FOLDERS)
                .setSelectFolderEnabled(true)
                .setIncludeFolders(true)
                .setMimeTypes('application/vnd.google-apps.folder'))
                .setOAuthToken(this.accessToken)
                .setDeveloperKey(this.apiKey)
                .setAppId(this.appId)
                .setCallback((data) => this.onDirectoryPickerCallback(data))
                .setTitle('googleDrive.directoryPicker.selectDirectory'.t())
                .build();
            picker.setVisible(true);
            this.loading = false;
        }
        catch (error) {
            console.error('Failed to create native picker:', error);
            // Check if this is a 403 authentication error
            if (error.message && error.message.includes('403')) {
                console.log('403 error detected - attempting to refresh token and retry');
                this.handleTokenRefreshAndRetry();
            }
            else {
                this.notifyService.notify('googleDrive.picker.createError'.t(), 'error');
                this.loading = false;
            }
        }
    }
    /**
     * Handle token refresh and retry picker creation
     */
    async handleTokenRefreshAndRetry() {
        try {
            console.log('Attempting to refresh Google Drive token...');
            // Try to get a fresh token from the backend
            const refreshedToken = await this.getExistingAccessToken();
            if (refreshedToken && refreshedToken !== this.accessToken) {
                console.log('New token obtained, retrying picker creation');
                this.accessToken = refreshedToken;
                this.createNativePicker();
            }
            else {
                // Token refresh failed, inform user they need to reconnect
                console.error('Token refresh failed, user needs to reconnect Google Drive');
                this.notifyService.notify('googleDrive.picker.tokenExpired'.t(), 'error');
                this.loading = false;
            }
        }
        catch (error) {
            console.error('Failed to refresh token:', error);
            this.notifyService.notify('googleDrive.picker.refreshFailed'.t(), 'error');
            this.loading = false;
        }
    }
    /**
     * Handle the native directory picker callback
     */
    onDirectoryPickerCallback(data) {
        console.log('🔍 PICKER CALLBACK - Raw data received:', JSON.stringify(data, null, 2));
        if (data.action === google.picker.Action.PICKED) {
            console.log('✅ PICKER ACTION: Directory picked');
            console.log('📁 Raw docs array:', data.docs);
            const folder = data.docs[0];
            console.log('📂 First folder object:', JSON.stringify(folder, null, 2));
            if (folder && folder.mimeType === 'application/vnd.google-apps.folder') {
                const selectedDirectory = {
                    id: folder.id,
                    name: folder.name,
                    mimeType: folder.mimeType,
                    modifiedTime: folder.lastEditedUtc,
                    webViewLink: folder.url
                };
                console.log('🎯 CONSTRUCTED selectedDirectory object:', JSON.stringify(selectedDirectory, null, 2));
                console.log('🚀 Emitting directory-selected event with:', { directory: selectedDirectory });
                this.$emit('directory-selected', { directory: selectedDirectory });
                this.selectedDirectory = selectedDirectory;
                this.buttonText = `${'googleDrive.directoryPicker.selected'.t()}: ${selectedDirectory.name}`;
                console.log('✨ Directory selection completed successfully');
            }
            else {
                console.warn('⚠️ Invalid folder object or not a folder:', folder);
            }
        }
        else if (data.action === google.picker.Action.CANCEL) {
            console.log('Directory picker cancelled');
            this.$emit('picker-cancelled');
        }
    }
};
exports.GoogleDriveDirectoryPicker = GoogleDriveDirectoryPicker;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GoogleDriveDirectoryPicker.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GoogleDriveDirectoryPicker.prototype, "pickerApiLoaded", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GoogleDriveDirectoryPicker.prototype, "gisLoaded", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], GoogleDriveDirectoryPicker.prototype, "accessToken", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], GoogleDriveDirectoryPicker.prototype, "buttonText", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], GoogleDriveDirectoryPicker.prototype, "selectedDirectory", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], GoogleDriveDirectoryPicker.prototype, "buttonClass", void 0);
exports.GoogleDriveDirectoryPicker = GoogleDriveDirectoryPicker = __decorate([
    (0, client_1.RWSView)('google-drive-directory-picker', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], GoogleDriveDirectoryPicker);
GoogleDriveDirectoryPicker.defineComponent();
